export const PaymentTypes = {
  Checkout: 'salesforce_provided',
  WithoutCheckout: 'publisher_provided'
};
export const ModelTypes = {
  Free: 'free',
  Freemium: 'freemium',
  FreeToInstall: 'free_to_install',
  Paid: 'paid'
};
export const SubscriptionPricePlan = {
  External: 'external',
  SelfCheckout: 'self_checkout'
};
export const UnitTypes = {
  Custom: 'custom',
  User: 'user',
  Company: 'company'
};